import BasePerimeter from './BasePerimeter';

export default new BasePerimeter({
  purpose: 'user',

  can: {
    all() {
      return this.hasPermission('user-read');
    },

    create() {
      return this.hasPermission('user-write');
    },

    read() {
      return this.hasPermission('user-read');
    },

    update(user) {
      return this.hasPermission('user-update') || this.isCreator(user);
    },

    destroy() {
      return this.hasPermission('user-delete');
    }
  },

  isCreator(user) {
    if (!user) return false;

    return this.child.id === user.child_id;
  }
});
